import state from './callState'
import mutations from './callMutations'
import getters from './callGetters'
import actions from './callActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
